import { IssueEventPhotos } from './IssueEventPhotos'

import type { GisIssueEvent } from '../../../api/types'

/** Human labels per event_type; unknown types fall back to a de-underscored string. */
const EVENT_LABELS: Record<string, string> = {
  raised: 'Raised',
  remark: 'Remark',
  resolved_by_hod: 'Resolved by HOD',
  rejected_by_hod: 'Rejected by HOD',
  completed: 'Completed',
  manual_override: 'Manual override',
}

const eventLabel = (t: string): string => EVENT_LABELS[t] ?? t.replace(/_/g, ' ')

const DOT: Record<string, string> = {
  raised: 'border-gis-navy',
  resolved_by_hod: 'border-gis-green',
  rejected_by_hod: 'border-gis-red',
  completed: 'border-gis-green',
}
const dotCls = (t: string): string => DOT[t] ?? 'border-[#f59e0b]'

/** Issue event timeline, rendered in array order (oldest → newest, per the contract). */
export function IssueTimeline({ events }: { events: GisIssueEvent[] }) {
  if (events.length === 0) {
    return <div className="text-muted-text py-2 text-xs">No timeline events.</div>
  }
  return (
    <div className="relative">
      {events.map((e, i) => {
        const last = i === events.length - 1
        return (
          <div
            key={e.id}
            className={`relative ml-[5px] pb-[18px] pl-[26px] ${last ? 'border-l-2 border-transparent pb-0' : 'border-l-2 border-gis-line'}`}
          >
            <span className={`absolute top-[1px] left-[-7px] box-border h-3 w-3 rounded-full border-[2.5px] bg-white ${dotCls(e.type)}`} />
            <div className="flex items-baseline justify-between gap-[10px]">
              <span className="text-[12.5px] font-bold text-gis-ink">{eventLabel(e.type)}</span>
              <span className="flex-none text-[11px] font-medium text-gis-muted tabular-nums">{e.createdAt.slice(0, 16).replace('T', ' ')}</span>
            </div>
            {e.actorName && <div className="mt-[3px] text-[11.5px] font-medium text-gis-soft">{e.actorName}{e.actorRole ? ` · ${e.actorRole}` : ''}</div>}
            {e.note && <p className="mt-[5px] text-[11.5px] leading-[1.5] text-gis-ink-2">{e.note}</p>}
            <IssueEventPhotos urls={e.photoUrls} />
          </div>
        )
      })}
    </div>
  )
}
